import avatar from "../assets/Avatar.png";
import {useEffect, useState} from "react";
import dateUtils from "../utils/DateUtils";


const ExternalUserComment = (props) => {

    const comment = props.comment;
    const date = props.date;
    const user = props.user;
    const status = props.status_id;
    const [name, setName] = useState("")
    const valuerChat = props.valuerChat

    useEffect(() => {
        if (!user) return;
        if (valuerChat) {
            setName(user.firstname + " " + user.lastname)
        } else {
            setName(user.firstname + " " + user.lastname)
        }
    },[user])

    return (
        <>
            <div className="valuation-user-comment-container">
                <div className="valuation-comment-img-container external-user">
                    <img src={avatar} alt="avatar"/>
                </div>
                <div className="valuation-comment-text-container">
                    <div className="valuation-name-container external-user">
                        {name}
                    </div>
                    <div className="valuation-message-container external-user">
                        <div className="valuation-message-text-container">
                            {comment}
                        </div>
                        <div className="valuation-message-date-container">
                            <div className="valuation-info-time-container">
                                {dateUtils.display_date_time(date*1000)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default ExternalUserComment